import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, object = authed
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip the /me check.
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    async function login(email, password) {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) localStorage.setItem("sd_token", data.access_token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
        }
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (_) {}
        try {
            await api.post("/auth/google/logout");
        } catch (_) {}
        localStorage.removeItem("sd_token");
        setUser(false);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh: checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
